export const WEATHER_API_KEY = `70b0bdefd6b84baa7449b2155d0dd184`;
export const MAPBOX_API_KEY = `pk.eyJ1IjoibGFudnd3IiwiYSI6ImNrdXIxdHVuejBpMWQydnBqY2JrMzVobjYifQ.wXmDID7ZWPjlbJsxCMAb3Q`;
